import { useRef } from 'react';
import { BodyText, Tooltip } from '@bamboohr/fabric';

export interface EmployeeNumberClockInIdTableCellProps {
	clockInId: string | null;
}

export function EmployeeNumberClockInIdTableCell({
	clockInId,
}: EmployeeNumberClockInIdTableCellProps) {
	const tooltipAnchorRef = useRef();

	if (clockInId === null) {
		return (
			<>
				<Tooltip
					anchorRef={tooltipAnchorRef}
					content={$.__('Add employee number on their personal tab.')}
					title={$.__('Missing Employee Number')}
				/>
				<BodyText
					color="warning"
					containerRef={tooltipAnchorRef}
					icon="triangle-exclamation-solid"
				>
					{$.__('Missing Employee Number')}
				</BodyText>
			</>
		);
	}

	if (isNaN(Number(clockInId))) {
		return (
			<>
				<Tooltip
					anchorRef={tooltipAnchorRef}
					content={$.__(
						'Clock-In ID must be numerical. You can update this on their employee tab.',
					)}
				/>

				<BodyText
					color="warning"
					containerRef={tooltipAnchorRef}
					icon="triangle-exclamation-solid"
				>
					{clockInId}
				</BodyText>
			</>
		);
	}

	return <>{clockInId}</>;
}
